import SvgIcon, { SvgIconProps } from '../components/SvgIcon';

interface Props extends SvgIconProps {
  /** @default 'outlined' */
  variant?: 'outlined' | 'filled';
}

const ChevronUpIcon = ({ variant = 'outlined', ...props }: Props) => {
  return (
    <SvgIcon
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18 15C17.7664 15.0005 17.5399 14.9191 17.36 14.77L12 10.29L6.63 14.61C6.52772 14.6931 6.41002 14.7551 6.28368 14.7925C6.15734 14.83 6.02485 14.8421 5.89382 14.8281C5.76279 14.8142 5.63581 14.7745 5.52017 14.7113C5.40454 14.6481 5.30253 14.5627 5.22 14.46C5.13694 14.3577 5.07491 14.24 5.03747 14.1137C5.00004 13.9873 4.98795 13.8549 5.00189 13.7238C5.01583 13.5928 5.05552 13.4658 5.1187 13.3502C5.18187 13.2345 5.26728 13.1325 5.37 13.05L11.37 8.22001C11.5489 8.07293 11.7734 7.99252 12.005 7.99252C12.2366 7.99252 12.4611 8.07293 12.64 8.22001L18.64 13.22C18.7413 13.304 18.825 13.4071 18.8863 13.5234C18.9477 13.6398 18.9855 13.7671 18.9975 13.898C19.0096 14.029 18.9957 14.1611 18.9567 14.2867C18.9176 14.4123 18.8542 14.529 18.77 14.63C18.677 14.7447 18.5596 14.8374 18.4265 14.9014C18.2934 14.9653 18.1477 14.999 18 15Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};

export default ChevronUpIcon;
